module.exports = __webpack_public_path__ + "img/timeline_mainevent-1.9faa209f.jpg";